<template>
  <div class="latest">
    <div class="latest-content-vedio" :style="setDisplay()">
      <div class="latest-content-vedioTitle">
        {{$t("mobileVideo")}}
        <el-select @change="selectDeviceSerial($event)" v-model="deviceSerialSelect">
          <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceSerialList"></el-option>
        </el-select>
      </div>
      <div id="video-container" class="latest-content-vedioFrm" v-if="showFlg"></div>
    </div>
    <div :class="!disFlg ? 'latest-content-data1' : 'latest-content-data'">
      <div v-for="(item,index) in itemList" :key="index" style="width: 90%">
        <div class="latest-content-cell">
          <div class="latest-content-cellName">
            {{item.name}} <br/>
            <p class="latest-content-cellTs">{{item.ts}}</p>
          </div>
          <div class="latest-content-cellValue">
            {{item.value}}
          </div>
          <div class="latest-content-cellImg">
            <img :src="getImgSrc(index)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import EZUIKit from 'ezuikit-js'
  import {getAttributesShared} from "../untils/api/home";
  import axios from "axios";
  export default {
    name: 'latestData',
    components: {
      EZUIKit,
      axios
    },
    data() {
      return {
        itemList:[],
        disFlg: false,
        deviceIDStr: '',
        player: null,
        accessToken: '',
        newURL:'',
        appKey: '',
        secret: '',
        defaultDevice:'',
        showFlg: false,
        address:[],
        deviceSerialSelect: '',
        deviceSerialList: [],
        windowWidth: document.documentElement.clientWidth,
        appKeyStr: '',
        time: null,
        channelNo: 1,
      }
    },

    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
    },

    methods:{
      /**
       * 转换最新遥测的格式
       * @param response
       */
      getDeviceItems(response, warnList) {
        this.itemList = [];
        let arrList = [];
        let levelRefer = localStorage.getItem('levelRefer'); //获取设置水位值
        let snowRefer = localStorage.getItem('snowRefer');//获取设置雪深值
        let emptyHRefer = localStorage.getItem('emptyHRefer');//获取设置空高值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声
        let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
        let TGFlg = localStorage.getItem("TG") === "TG" ? true : false;
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        for(let obj in response){
          let arrJson = {};
          arrJson.name = this.$t(obj);
          arrJson.ts = response[obj][0].ts;
          if(obj == 'level' || obj == 'Rwater' || obj == 'waterlevel') { //当前为水位属性
            arrJson.value = Math.abs(parseFloat(levelRefer) + parseFloat(response[obj][0].value)).toFixed(4).toString();
          } else if(obj == 'snowHeight' || obj == 'snowheight'){
            arrJson.value = Math.abs(parseFloat(snowRefer) + parseFloat(response[obj][0].value)).toFixed().toString();
          } else if(obj == 'noise' || obj == 'noi' || obj == 'noise1' || obj == 'noise2') {
            arrJson.value = Math.abs(parseFloat(noiseRefer) + parseFloat(response[obj][0].value)).toFixed(1).toString();
          } else if(obj == 'flowNum') {
            arrJson.value = (parseFloat(response[obj][0].value) * 6.28).toFixed(1).toString();
          } else if(obj == 'emptyH' && !(emptyHRefer.toString() == '0')) {
            arrJson.value = response[obj][0].value;
            let level = (parseFloat(emptyHRefer) - parseFloat(response[obj][0].value)) < 0 ? 0 : parseFloat(emptyHRefer) - parseFloat(response[obj][0].value);
            let flowNum =  (level *2399.5).toFixed(4).toString();
            arrList.push({
              name: '瞬时流量,L/dm³',
              ts: response[obj][0].ts,
              value: flowNum
            })

          } else if(obj == 'ammoniaIon') {
            if(response.hasOwnProperty('waterPH')) {
              let amnitro = parseFloat(response['ammoniaIon'][0].value);
              let waterPH = parseFloat(response['waterPH'][0].value);
              if(response.hasOwnProperty('waterT')) {
                let waterT = parseFloat(response['waterT'][0].value);
                let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
                let amnitroResult = result.toFixed(2);
                arrJson.value = amnitroResult;
              } else {
                let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
                let amnitroResult = parseFloat(result).toFixed(2);
                arrJson.value = amnitroResult;
              }
            } else {
              arrJson.value = parseFloat(response[obj][0].value).toString();
            }
          } else if(HIFlg == true && obj == 'ambientHumidity') {
            arrJson.value = response['ambientHumidity'][0].value;
            if(response.hasOwnProperty('ambientTemperature')) {
              let T = response['ambientTemperature'][0].value;
              let RH = response['ambientHumidity'][0].value;
              let HI = this.calculateHeatIndex(T, RH).toFixed(3);
              arrList.push({
                name: '热量指数',
                ts: response[obj][0].ts,
                value: HI
              })
            }
          } else if(TGFlg == true && obj == 'ambientTemperature') {
            arrJson.value = response['ambientTemperature'][0].value;
            if(response.hasOwnProperty('ambientHumidity') && response.hasOwnProperty('windSpeed')) {
              let temp = parseFloat(response['ambientTemperature'][0].value);
              let hum = parseFloat(response['ambientHumidity'][0].value);
              let speed = parseFloat(response['windSpeed'][0].value);
              let AT = this.calculateAT(temp, hum, speed).toFixed(2);
              arrList.push({
                name: this.$t('AT'),
                ts: response[obj][0].ts,
                value: AT
              })
            }
          } else if(WDFlg == true && obj == 'windDirection') {
            arrJson.value = (response[obj][0].value + ".0");
          } else if(obj == 'Rday1') {
            arrJson.value = (parseFloat(response[obj][0].value )* 0.36).toFixed(2);
          } else {// 当前为非水位属性
            arrJson.value = response[obj][0].value;
          }
          arrJson.flg = 'normal';
          for(let upLow in warnList) {
            if(warnList[upLow].name === obj){
              arrJson.flg = warnList[upLow].flg;
            }
          }
          arrList.push(arrJson);
        }
        //倒叙排序
        arrList.sort(function (a,b) {
          return b.ts < a.ts ? -1 : 1
        });

        //换成符合条件的数据
        for(let i = 0; i < arrList.length; i++) {
          let itemJson = {};
          if(arrList[i].name.split(',')[0] == '天气状况') {
            itemJson.ts = this.dateFormat(arrList[i].ts);
            itemJson.name = arrList[i].name.split(',')[0];
            switch (parseInt(arrList[i].value)) {
              case 0:
                itemJson.value = "晴";
                break;
              case 16:
                itemJson.value = "大雨";
                break;
              case 17:
                itemJson.value = "中雨";
                break;
              case 18:
                itemJson.value = "小雨";
                break;
              case 32:
                itemJson.value = "大毛毛雨";
                break;
              case 33:
                itemJson.value = "中毛毛雨";
                break;
              case 34:
                itemJson.value = "小毛毛雨";
                break;
              case 50:
                itemJson.value = "大雪";
                break;
              case 51:
                itemJson.value = "中雪";
                break;
              case 52:
                itemJson.value = "小雪";
                break;
              case 64:
                itemJson.value = "烟";
                break;
              case 80:
                itemJson.value = "雾";
                break;
              case 96:
                itemJson.value = "冰雪或高空坠物";
                break;
              case 153:
                itemJson.value = "飞虫或异常遮挡";
                break;
            }
            this.itemList.push(itemJson);
          } else {
            itemJson.ts = this.dateFormat(arrList[i].ts);
            itemJson.name = arrList[i].name.split(',')[0];
            itemJson.value = arrList[i].name.split(',')[1] === undefined ? arrList[i].value : arrList[i].value + arrList[i].name.split(',')[1];
            itemJson.flg = arrList[i].flg;
            this.itemList.push(itemJson);
            if(arrList[i].name.split(',')[0] === '风向'){
              let windName = '';
              if(arrList[i].value < 22.5 || arrList[i].value >= 337.5 ) {
                windName = '北风';
              } else if(arrList[i].value >= 22.5 && arrList[i].value < 67.5){
                windName = '东北风';
              }else if(arrList[i].value >= 67.5 && arrList[i].value < 112.5) {
                windName = '东风';
              } else if(arrList[i].value >= 112.5 && arrList[i].value < 157.5){
                windName = '东南风';
              } else if(arrList[i].value >= 157.5 && arrList[i].value < 202.5) {
                windName = '南风';
              } else if(arrList[i].value >= 202.5 && arrList[i].value < 247.5) {
                windName = '西南风';
              } else if(arrList[i].value >= 247.5 && arrList[i].value < 292.5) {
                windName = '西风'
              } else if(arrList[i].value >= 292.5 && arrList[i].value < 337.5) {
                windName = '西北风';
              }
              let windJson = {};
              windJson.ts = this.dateFormat(arrList[i].ts);
              windJson.name = '风向';
              windJson.value = windName;
              this.itemList.push(windJson);
            }
          }
        }
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      calculateAT(temp, hum, speed) {
        let e = hum/100*6.105*2.71828*17.27*temp/(237.7+temp);
        let AT = 1.07*temp+0.2*e-0.65*speed-2.7;
        return AT;
      },

      /**
       * 根据设备获取 appKey secret deviceSerial
       * @param deviceId
       */
      getMobileVedioShare(device) {
        if(this.deviceIDStr !== device.id){
          this.disFlg = false;
          this.appKey = '';
          this.secret = '';
          this.address = [];
          this.deviceSerialList = [];
          this.defaultDevice = '';
          this.deviceSerialSelect = '';
          let num = 0;
          clearInterval(this.time);
          this.time = null;

          //访问api
          getAttributesShared(device.entityType, device.id).then(response => {
            for(let i = 0; i < response.length; i++){
              if(response[i].key.toString().indexOf('vedio') !== -1) {
                this.disFlg = true;
                let json = JSON.parse(response[i].value);
                let deviceSerialJson = {};
                deviceSerialJson.id = num; //设备id
                deviceSerialJson.name = json.deviceSerial;//设备名
                this.deviceSerialSelect = num;// 选中设备id
                this.address.push(json);
                this.appKey = json.appKey;
                this.secret = json.secret;
                this.channelNo = 1;
                if(json.deviceSerial.indexOf('-') !== -1) {
                  this.defaultDevice = json.deviceSerial.split("-")[0];
                  this.channelNo = json.deviceSerial.split("-")[1];
                } else {
                  this.defaultDevice = json.deviceSerial;//选中的设备
                }
                this.deviceSerialList.push(deviceSerialJson);//设备列表
                num++;
              }
            }
            if(this.appKey !== '' && this.secret !== '' && this.defaultDevice !== '') {//appKey secret deviceSerial 均存在
              this.showFlg = true;
              this.setMobileVedio();
            } else {//appKey secret deviceSerial 均不存在
              this.showFlg = false;
            }
          }).catch(error => {
            console.log("error",error)
          })
          this.deviceIDStr = device.id;
        }
      },

      /**
       * 获取ccesstoken url
       */
      setMobileVedio(){
        Promise.all([
          this.getMobileVedioToken()
        ]).then(res => {
          Promise.all([
            this.getMobileVedioURL()
          ]).then(res => {
            this.playMobileVedio();
            this.time = window.setInterval(() => {
              setTimeout(() => {
                this.playMobileVedio();
              },0)
            },1000 * 60 * 10)
          })
        })
      },

      /**
       * 播放监控
       */
      playMobileVedio() {
        document.getElementById('video-container').innerHTML = "";
        this.player = null;

        this.player = new EZUIKit.EZUIKitPlayer({
          autoplay: true,
          id: "video-container", // 视频容器ID
          accessToken: this.accessToken,
          url: this.newURL,
          template: 'simple',//theme simple standard security
          width: this.windowWidth * 0.96,
          height: this.windowWidth * 0.75,
        })
      },

      /**
       * 获取accessToken
       */
      getMobileVedioToken() {
        let url =  '/api/lapp/token/get?appKey=' + this.appKey + '&appSecret=' + this.secret;
        return axios({
          method: 'post',
          baseURL: process.env.API, // 修改这里
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then((response) => {
          this.accessToken = response.data.accessToken;
        }).catch((error) => {
          console.log("error",error)
        })
      },

      /**
       * 获取URL
       */
      getMobileVedioURL() {
        let url = '/api/lapp/v2/live/address/get?accessToken=' + this.accessToken + '&deviceSerial=' + this.defaultDevice + '&channelNo=' + this.channelNo;
        return axios({
          method: 'post',
          baseURL: process.env.API, // 修改这里
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then((response) => {
          this.newURL = response.data.url;
        }).catch((error) => {
          this.newURL = 'ezopen://open.ys7.com/' + this.defaultDevice + '/1.hd.live';
          console.log("error",error);
        })
      },

      /**
       * 根据选中的设备获取url
       * @param event
       */
      selectDeviceSerial(event) {
        this.appKey = this.address[event].appKey;//appley
        this.secret = this.address[event].secret;//secret
        let deviceNum = this.address[event].deviceSerial;//选中设备名称
        this.channelNo = 1;
        if(deviceNum.indexOf('-') !== -1) {
          this.defaultDevice = deviceNum.split("-")[0];
          this.channelNo = deviceNum.split("-")[1];
        } else {
          this.defaultDevice = deviceNum;//选中的设备
        }
        this.deviceSerialSelect = event;//选中设备id
        clearInterval(this.time);
        this.time = null;
        this.setMobileVedio();
      },

      /**
       * 将时间戳转换成时间格式
       * @param timestamp
       * @returns {string}
       */
      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      /**
       * 切换图片
       * @param index
       */
      getImgSrc(index){
        if(this.itemList[index].flg === 'up') {
          return require('./img/up.png');
        } else if(this.itemList[index].flg === 'low') {
          return require('./img/low.png');
        } else {
          return require('./img/normal.png');
        }
      },

      /**
       * 设置监控模块是否显示
       *
       */
      setDisplay() {
        if(!this.disFlg){
          return {
            display: 'none'
          };
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @media screen and (max-width: 500px) {
    .latest {
      margin-top: 2%;
    }

    .latest-content-vedio {
      width: 98%;
      height: 45%;
      position: absolute;
      top: 1%;
      margin-left: 1%;
    }

    .latest-content-vedioTitle {
      width: 97%;
      height: 9%;
      margin-left: 3%;
    }

    .latest-content-vedioFrm {
      margin-top: 2%;
      width: 100%;
      height: 89%;
      margin-left: 1%;
      display: block !important;
    }

    .latest-content-data {
      width: 100%;
      overflow: auto;
      position: absolute;
      top: 48%;
      bottom: 0.1%;
    }

    .latest-content-data1 {
      width: 100%;
      overflow: auto;
      position: absolute;
      top: 1%;
      bottom: 0.1%;
    }

    .latest-content-cell {
      height: 15vw;
      width: 100%;
      margin-bottom: 2%;
      border: 1px outset #314963;
      background-color: #314963;
      display: flex;
      justify-content: space-between;
      border-radius: 50px;
      margin-left: 5%;
    }

    .latest-content-cellName {
      width: 55%;
      font-size: 4vw;
      color: #fc857a;
      margin: auto;
      text-align: center;
      padding-left: 3%;
    }

    .latest-content-cellTs {
      color: #dbdbdb;
      font-size: 3vw;
    }

    .latest-content-cellValue {
      width: 35%;
      font-size: 4vw;
      color: #83e2fd;
      font-weight: bold;
      text-align: center;
      margin: auto;
      margin-right: 2%;
    }

    .latest-content-cellImg {
      width: 10%;
      margin-right: 5%;
      margin-top: 3%;
    }

    /deep/ .el-input__inner {
      height: 6vw;
      width: 28vw;
      font-size: 3vw;

      background-color: #1c2735;
      outline: none;
      /*border: none;*/
      border: thin double  #34455f;//#15FEDA #1296db
      border-radius: 40px;
      color: #83e2fd;//#1890ff #15FEDA
      appearance: none;
      -webkit-appearance: none;
    }

    .el-select-dropdown__item {
      line-height: 100px;
      height: 5vw;
      font-size: 3.5vw;
    }

    /deep/ .el-input__icon {
      width: 3vw;
      /*line-height: 4vw;*/
    }

    /deep/.el-select-dropdown__wrap,.el-scrollbar__warp {
      min-height: 5rem !important;
      min-width: 1rem !important;
    }

    /deep/.el-select .el-input .el-select__caret{
      color: #83e2fd;
      font-size: 3vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/latestData.vue